import * as React from 'react';
import { MailFolderList } from 'owa-mail-folder-view';
import { observer } from 'mobx-react';
import toggleFolderNodeExpansion from 'owa-mail-folder-store/lib/actions/toggleFolderNodeExpansion';
import { ActionSource } from 'owa-mail-store';
import {
    getSharedFolderRoot,
    lazyGetSharedFoldersForSpecificRoot,
    getMailboxLoadingState,
    Folder,
    SHARED_FOLDERS_TREE_TYPE,
    PRIMARY_DELETED_ITEMS_DISTINGUISHED_ID,
} from 'owa-folders';
import getFolderViewStateFromId from 'owa-mail-folder-store/lib/selectors/getFolderViewStateFromId';
import { lazyDeleteFolderInFolderForest } from 'owa-mail-folder-forest-actions';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';

export interface SharedFolderTreeProps {
    principalSMTPAddress: string;
    className: string;
}

/**
 * Shared folder tree of a specific user
 */
function SharedFolderTree(props: SharedFolderTreeProps) {
    const { principalSMTPAddress, className } = props;
    const rootFolder = getSharedFolderRoot(principalSMTPAddress);
    const isSharedFolderRootExpanded = getFolderViewStateFromId(principalSMTPAddress).isExpanded;

    const onRootNodeChevronClicked = async () => {
        (await lazyGetSharedFoldersForSpecificRoot.import())(
            principalSMTPAddress,
            'folderPane' /* actionSource */
        );
        toggleFolderNodeExpansion(principalSMTPAddress, true);
    };

    const onDeleteFolder = (folder: Folder, actionSource: ActionSource) => {
        const primaryDeletedItemsFolderId = folderNameToId(PRIMARY_DELETED_ITEMS_DISTINGUISHED_ID);

        lazyDeleteFolderInFolderForest.importAndExecute(
            folder.FolderId.Id,
            actionSource,
            primaryDeletedItemsFolderId,
            false /* isFolderUnderDeletedItemFolder */
        );
    };
    return (
        <MailFolderList
            className={className}
            key={principalSMTPAddress}
            showRootNode={true}
            rootFolder={rootFolder}
            isRootExpanded={isSharedFolderRootExpanded}
            rootDisplayName={rootFolder.DisplayName}
            childFolderIds={rootFolder.childFolderIds}
            onRootNodeChevronClickedCallback={onRootNodeChevronClicked}
            treeType={SHARED_FOLDERS_TREE_TYPE}
            isFavoritesSupported={false}
            onDeleteFolderCallback={onDeleteFolder}
            loadingState={getMailboxLoadingState(principalSMTPAddress)}
        />
    );
}

export default observer(SharedFolderTree);
